if (!customElements.get('icraft-postcode-checker')) {
  customElements.define('icraft-postcode-checker', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events=new AbortController(); this.sequence=0;
      this.form=this.querySelector('form'); this.result=this.querySelector('[role=status]');
      this.button=this.form.querySelector('button');
      this.messages=JSON.parse(this.querySelector('[data-messages]').textContent);
      this.root=this.dataset.root.replace(/\/?$/,'/');
      this.product=this.closest('.icraft-product');
      this.form.addEventListener('submit',event=>{event.preventDefault();this.calculate();},{signal:this.events.signal});
      this.form.addEventListener('input',()=>this.invalidate(),{signal:this.events.signal});
      this.product?.addEventListener('on:variant:change',event=>{
        const variant=event.detail?.variant;
        this.dataset.variantId=variant?.id||'';
        this.dataset.available=String(Boolean(variant?.available));
        if(variant&&typeof variant.requires_shipping==='boolean')this.dataset.requiresShipping=String(variant.requires_shipping);
        this.invalidate();
      },{signal:this.events.signal});
      const quantityChange=event=>{if(event.target.matches('[name=quantity],input[name^="updates"]'))this.invalidate();};
      document.addEventListener('input',quantityChange,{signal:this.events.signal});
      document.addEventListener('change',quantityChange,{signal:this.events.signal});
      ['on:cart:change','cart:updated','cart:refresh'].forEach(name=>document.addEventListener(name,()=>this.invalidate(),{signal:this.events.signal}));
      window.addEventListener('pageshow',()=>this.invalidate(),{signal:this.events.signal});
      if(this.dataset.context==='cart'){
        let timer;
        this.observer=new MutationObserver(()=>{clearTimeout(timer);timer=setTimeout(()=>this.invalidate(),150);});
        const cart=document.querySelector('main-cart,cart-items,#cart-items,.cart-items');
        if(cart)this.observer.observe(cart,{childList:true,subtree:true});
      }
    }
    disconnectedCallback(){this.events?.abort();this.request?.abort();this.observer?.disconnect();clearTimeout(this.timeout);}
    invalidate(){this.sequence++;this.request?.abort();clearTimeout(this.timeout);this.button.disabled=false;this.removeAttribute('aria-busy');if(!this.result.hidden)this.show('changed');}
    show(key){this.result.replaceChildren(document.createTextNode(this.messages[key]||this.messages.error));this.result.hidden=false;}
    line(text,tag='p'){const el=document.createElement(tag);el.textContent=text;this.result.append(el);}
    money(cents){return new Intl.NumberFormat('en-AU',{style:'currency',currency:'AUD'}).format(cents/100);}
    async getLines(signal){
      if(this.dataset.context==='cart'){
        const response=await fetch(`${this.root}cart.js`,{signal,cache:'no-store'});if(!response.ok)throw Error('cart');
        const cart=await response.json();
        return cart.items.map(item=>({variantId:String(item.variant_id),quantity:item.quantity,productType:item.product_type||'',requiresShipping:item.requires_shipping!==false}));
      }
      const quantity=Number(this.product?.querySelector('.product-info [name=quantity]')?.value||1);
      return [{variantId:this.dataset.variantId,quantity,productType:this.dataset.productType||'',requiresShipping:this.dataset.requiresShipping!=='false'}];
    }
    async calculate(){
      if(!this.form.reportValidity())return;
      this.invalidate();const seq=this.sequence,request=new AbortController();this.request=request;
      this.timeout=setTimeout(()=>request.abort(),20000);this.button.disabled=true;this.setAttribute('aria-busy','true');this.show('loading');
      try{
        if(this.dataset.context==='product'&&this.dataset.available!=='true'){this.show('unavailable');return;}
        const lines=await this.getLines(request.signal);
        if(seq!==this.sequence)return;
        if(!lines.length){this.show('empty_cart');return;}
        if(lines.some(line=>!/^\d+$/.test(line.variantId)||!Number.isSafeInteger(line.quantity)||line.quantity<1)){this.show('invalid_quantity');return;}
        if(!this.rules){const r=await fetch(this.dataset.rulesUrl,{signal:request.signal});if(!r.ok)throw Error('rules');this.rules=await r.json();}
        if(seq!==this.sequence)return;
        const address={country:'AU',state:this.form.elements.state.value,postcode:this.form.elements.postcode.value.trim()};
        const quote=window.ICraftPostcodeEngine.quote(this.rules,address,lines);
        if(quote.status!=='estimate'){this.show(quote.status);return;}
        this.show('estimate');
        this.line(this.money(quote.amountCents),'strong');
        this.line(`${quote.quantity} ${quote.quantity===1?this.messages.chair:this.messages.chairs} × ${this.money(quote.unitCents)} ${this.messages.unit}`);
        this.line(this.messages.current_note);
      }catch(error){if(seq===this.sequence)this.show('error');}
      finally{if(seq===this.sequence){clearTimeout(this.timeout);this.button.disabled=false;this.removeAttribute('aria-busy');}}
    }
  });
}
